import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonLogicModule } from '../../index';
import { ListSearchComponent } from './list-search.component';

@NgModule({
    imports: [
        CommonLogicModule,
        ReactiveFormsModule,
        ListSearchComponent
    ],
    exports: [
        ListSearchComponent
    ],
    providers: []
})
export class ListSearchModule {}
